// razorpayConstants.js

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const CAPTURE_PAYMENT_REQUEST = 'CAPTURE_PAYMENT_REQUEST';
export const CAPTURE_PAYMENT_SUCCESS = 'CAPTURE_PAYMENT_SUCCESS';
export const CAPTURE_PAYMENT_FAILURE = 'CAPTURE_PAYMENT_FAILURE';
